import { getZonedDate } from '@eika-infrastruktur/date';

import type { TransferRequest } from '../../../../generated-types';
import makeMoneyTransfer from '../../../../services/transferService';
import nullableZonedDateToUtc from '../../../../utils/mapper/nullableZonedDateToUtc';
import { TransferState } from './state';

export default () => (transferState: TransferState) => {
    const transferDate = transferState.transferDate ?? getZonedDate();
    const request: TransferRequest = {
        fromAccountNumber: transferState.fromAccount!,
        toAccount: transferState.toAccount!,
        amount: transferState.amount!,
        currency: 'NOK',
        text: transferState.note,
        ownText: transferState.ownText || transferState.note,
        date: nullableZonedDateToUtc(transferDate)!,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return makeMoneyTransfer(request);
};
